import { BaseModel } from './base';

export class Municipio extends BaseModel {
  constructor(public id: number, public nome: string, public ibge: number) {
    super(id);
  }
}
